// Global
import React, { Component } from 'react';
import {
  func,
  oneOfType,
  object,
  array,
} from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { closeAlertDialog, closeConfirmDialog } from '../actions/dialog/dialogActions';
import { fetchAuthenticatedPreferences } from '../actions/preferences/preferencesAction';

// Page layout
import LoadingState from '../components/LoadingState';
import HeaderBar from '../components/HeaderBar/HeaderBar';
import Layout from '../components/Layout';
import MainMenu from '../components/MainMenu';
import PageMeta from '../components/PageMeta';
import PortalDialog from '../components/PortalDialog';
import Footer from "../components/Footer/Footer";


class AuthLayout extends Component {
  static propTypes = {
    alertDialog: object,
    children: oneOfType([
      array,
      object
    ]),
    confirmDialog: object,
    fetchAuthenticatedPreferences: func,
    fullPageLoadingState: object,
    loading: object,
    metadata: object,
    params: object,
    preferences: object,
    route: object,
    routeParams: object,
    router: object,
    routes: array,
  };

  componentWillMount() {
    this.props.fetchAuthenticatedPreferences();
  }

  // return true; from the child callback will close the dialog, otherwise it stays open
  handleAlertOkCallback = () => {
    if (!this.props.alertDialog.okCallback || this.props.alertDialog.okCallback()) {
      this.props.closeAlertDialog();
    }
  };

  // return true; from the child callback will close the dialog, otherwise it stays open
  handleConfirmOkCallback = () => {
    if (!this.props.confirmDialog.okCallback || this.props.confirmDialog.okCallback()) {
      this.props.closeConfirmDialog();
    }
  };

  render = () => {
    const logoUrl = this.props.account.location ? this.props.account.location.preferences.logoUrl : '';
    const path = this.props.location.pathname;

    return (
      <Layout column fullscreen staticX staticY>
        <PageMeta
          title={this.props.metadata.pageTitle}
          description={this.props.metadata.pageDescription}
        />
        <HeaderBar
          activeLocation={this.props.account.location}
          activeRoute={path}
          authenticatedPreferences={this.props.authenticatedPreferences}
          locations={this.props.locations}
          logoUrl={logoUrl}
        />
        <Layout staticX>
          <MainMenu
            activeItemKey={this.props.metadata.activeMenuItemKey}
          />

          {this.props.children}

        </Layout>
        {this.props.fullPageLoadingState.loading &&
          <LoadingState context="fullPageTakeOver" />
        }
        <PortalDialog
          id="alertDialog"
          open={this.props.alertDialog.open}
          error={this.props.alertDialog.error}
          title={this.props.alertDialog.title}
          content={this.props.alertDialog.content}
          okCallback={this.handleAlertOkCallback}
          okOnly
          modal
        />
        <PortalDialog
          id="confirmDialog"
          open={this.props.confirmDialog.open}
          error={this.props.confirmDialog.error}
          title={this.props.confirmDialog.title}
          content={this.props.confirmDialog.content}
          okCallback={this.handleConfirmOkCallback}
          cancelCallback={this.props.confirmDialog.cancelCallback}
          cancelLabel={this.props.confirmDialog.cancelLabel}
          okLabel={this.props.confirmDialog.okLabel}
          modal
        />
        <Footer />
      </Layout>
    );
  };
}

const mapStateToProps = (state) => ({
  alertDialog: state.alertDialog,
  account: state.account,
  authenticatedPreferences: state.authenticatedPreferences,
  confirmDialog: state.confirmDialog,
  fullPageLoadingState: state.fullPageLoadingState,
  loading: state.loadingState,
  locations: state.locations,
  metadata: state.metadata,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAuthenticatedPreferences: () => dispatch(fetchAuthenticatedPreferences()),
  closeAlertDialog: () => dispatch(closeAlertDialog()),
  closeConfirmDialog: () => dispatch(closeConfirmDialog()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthLayout);



// WEBPACK FOOTER //
// ./src/layouts/AuthLayout.js